import { FormType } from 'fourwaves-shared';

export default {
  withdraw_modal: {
    title: 'Withdraw {type}',
    subtitle: 'Please note that this action cannot be undone.',
    form_type: {
      [FormType.Registration]: 'Registration',
      [FormType.Submission]: 'Submission',
    },
    reason: 'Reason',
    success_message: 'Your {type} has been withdrawn successfully.',
    warning_alert: {
      [FormType.Registration]:
        'Additional action may be required on your part, as this registration could be linked to a submission and/or a transaction.',
      [FormType.Submission]:
        'Any reviews associated with this submission will be deleted. If the submission is in a session, it will remain visible, but marked as withdrawn.',
    },
  },
  mass_edit_modal: {
    action_button: 'Edit',
    title: 'Edit {formEntryType}',
    steps: {
      edit: {
        title: 'Edit',
        subtitle: 'Edit the value for all selected form entries.',
      },
      confirm: {
        title: 'Confirm',
        subtitle: "You're about to edit {count} {formEntryType}.",
      },
    },
    loading: {
      validate: 'Validating...',
      save: 'Mass updating...',
    },
    field: 'Field to edit',
    no_editable_fields: 'No editable fields',
    formEntryType: {
      [FormType.Review]: 'review | reviews',
      [FormType.Submission]: 'submission | submissions',
      [FormType.Registration]: 'registration | registrations',
    },
    warnings: {
      title: 'Warnings',
      hint: 'Warnings are informational only and do not prevent {formEntryType} from being updated.',
      required: 'The field "{label}" is required, but its value is left empty for {count} {formEntryType}.',
      field_choice_late_cost:
        'The field "{label}" has a late cost. Mass updating it will affect {count} {formEntryType}.',
      added_paid_choice:
        'The option "{choiceLabel}" of the "{label}" field has a cost of {cost}. Mass updating it will affect {count} {formEntryType}.',
      field_visibility_hidden: 'The conditional field "{label}" will now be hidden for {count} {formEntryType}.',
      field_visibility_visible: 'The conditional field "{label}" will now be visible for {count} {formEntryType}.',
      field_choice_date_between:
        'The option "{choiceLabel}" of the "{label}" field is only available between {startDate} and {endDate}. Mass updating it will affect {count} {formEntryType}.',
      field_choice_date_before:
        'The option "{choiceLabel}" of the "{label}" field is only available before {endDate}. Mass updating it will affect {count} {formEntryType}.',
      field_choice_date_after:
        'The option "{choiceLabel}" of the "{label}" field is only available after {startDate}. Mass updating it will affect {count} {formEntryType}.',
    },
    errors: {
      title: 'Errors',
      hint: 'Errors prevent {formEntryType} from being updated.',
      cannot_remove_paid_choice:
        'The option "{choiceLabel}" of the "{label}" field cannot be removed since it has a cost of {cost}. This prevents {count} {formEntryType} from being updated.',
      field_choice_quantity:
        'The option "{choiceLabel}" of the "{label}" field cannot be added since the quota of {totalQuota} would be exceeded. This prevents {count} {formEntryType} from being updated.',
    },
  },
};
